// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"style_textWrapper__1wDOA","text":"style_text__1XyGZ","bottom":"style_bottom__bW7JB"};